import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';



export const FC = styled(Box)(({theme}) => ({
  flex: '1 0',
  marginRight: theme.spacing(1)
}));
